import _ from 'lodash-es';
import angular from 'angular';
import { createNumberMask } from 'text-mask-addons';
import controller from './number.controller';
import template from './number.html';
import NumberComponent from './number.component';

const numberConfig = /* @ngInject */ (/** @type {any} */ KformComponentsProvider) => {
	KformComponentsProvider.register('number', {
		title: 'Number',
		template,
		/**
		 * @param {any} data
		 * @param {any} options
		 * @returns {any}
		 */
		tableView(data, options) {
			if (_.isNil(data)) {
				return '';
			}

			const {
				getNumberDecimalLimit,
				formatNumber,
				getNumberSeparators,
			} = options.util;
			const separators = getNumberSeparators();
			const { component } = options;
			const decimalLimit = getNumberDecimalLimit(component);

			if (!component.delimiter) {
				separators.delimiter = '';
			}

			return formatNumber(data, createNumberMask({
				prefix:        '',
				suffix:        '',
				delimiter:     _.get(component, 'thousandsSeparator', separators.delimiter),
				decimalSymbol: _.get(component, 'decimalSymbol', separators.decimalSeparator),
				decimalLimit:  _.get(component, 'decimalLimit', decimalLimit),
				allowNegative: _.get(component, 'allowNegative', true),
				allowDecimal:  _.get(component, 'allowDecimal', !(component.validate && component.validate.integer)),
			}));
		},
		children:                   false,
		selectable:                 true,
		settings:                   new NumberComponent(),
		icon:                       'fa fa-hashtag',
		views:                      [
			{
				name:     'Display',
				template: 'kform/components/number/display.html',
			},
			{
				name:     'Data',
				template: 'kform/components/number/data.html',
			},
			{
				name:     'Validation',
				template: 'kform/components/number/validate.html',
			},
			{
				name:     'API',
				template: 'kform/components/common/api.html',
			},
			{
				name:     'Layout',
				template: 'kform/components/common/layout.html',
			},
			{
				name:     'Conditional',
				template: 'kform/components/common/conditional.html',
			},
			{
				name:     'Events',
				template: 'kform/components/common/events.html',
			},
		],
		controller,
	});
};

export default angular.module('app')
	.config(numberConfig);
